import get from 'immutable-less/transmute/get';
import { useQuery } from 'data-fetching-client';
import TeamsAssetAccessPanel from 'ui-asset-management-lib/components/TeamsAssetAccessPanel';
import { GET_HIERARCHICAL_TEAMS_BY_USER } from 'automation-ui-management/queries/assignableTeamsQueries';
import { jsx as _jsx } from "react/jsx-runtime";
const UserTeamAssetAccessPanel = ({
  assetTypeDisplayName,
  assignedTeamIds,
  onCancel,
  onSave,
  showSaveLoading
}) => {
  const {
    data,
    error,
    loading
  } = useQuery(GET_HIERARCHICAL_TEAMS_BY_USER);
  return /*#__PURE__*/_jsx(TeamsAssetAccessPanel, {
    assetTypeDisplayName: assetTypeDisplayName,
    assignedTeamIds: assignedTeamIds,
    teams: get('assignableTeamsByUser', data) || [],
    onSave: onSave,
    onCancel: onCancel,
    requestsError: !!error,
    requestsLoading: loading,
    showSaveLoading: showSaveLoading
  });
};
export default UserTeamAssetAccessPanel;